module.exports = __webpack_public_path__ + "img/profile-image.b25bac83.jpg";